import React from 'react'
import { Link } from 'react-router-dom'

const LinkIcon = ({link , text}) => {
  return (
    <Link 
      to={link} 
      className='group flex items-center justify-between py-3 px-4 rounded-lg text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-all duration-200 hover:shadow-sm'
    >
        <div className='flex items-center'>
            <div className='font-medium text-sm group-hover:font-semibold'>
                {text}
            </div>
        </div>
        <svg className="w-4 h-4 text-gray-400 group-hover:text-blue-500 transition-colors duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
    </Link>
  )
}

export default LinkIcon
